import { render } from "./Standard.vue?vue&type=template&id=4289b0c6&scoped=true"
import script from "./Standard.vue?vue&type=script&lang=ts"
export * from "./Standard.vue?vue&type=script&lang=ts"

import "./Standard.vue?vue&type=style&index=0&id=4289b0c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4289b0c6"

export default script